import { Grid, IconButton, Tooltip } from "@material-ui/core";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import IconPen from "app/common/Icon/IconPen";
import { useStore } from "app/stores";
import { Add } from "@material-ui/icons";
import PopupNotePatient from "./Popup/PopupNotePatient";
import IconDelete from "app/common/Icon/IconDelete";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import { getDateTime } from "app/common/LocalFunction";

const ListNoteBlock = ({ initialPatient }) => {
  const {
    openConfirmDeleteNotePatient,
    handleDeleteNotePatient,
    handleOpenFormCreateOrEditNotePatient,
    openNoteCreateOrUpdate,
    handleClosePopupNotePatien,
    handleDeleteNote
  } = useStore().patientManagementStore.patientGeneralStore;
  const { t } = useTranslation();
  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        container
        spacing={1}
        className="m-0 w-100"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Ghi chú</p>
          <div className="flex align-center flex-end gap-1 cursor">
            <Tooltip title="Thêm ghi chú">
              <IconButton
                size="small"
                style={{ color: "#eb7d15" }}
              >
                <Add className="font-md" onClick={() => handleOpenFormCreateOrEditNotePatient()} />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          style={{ overflowY: "auto", maxHeight: "400px" }}
          className="custom-scrollbar"
        >
          {(initialPatient?.patientNotes || []).map((item, index) => (
            <div
              style={{
                padding: 5,
                display: "flex",
                justifyContent: "space-between",
                borderBottom: "1px solid gray",
              }}
            >
              <div
                style={{
                  paddingBottom: 12,

                  marginBottom: 12,
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <span className="text-medical">
                    {getDateTime(item?.noteDate)}
                  </span>
                  <span
                    style={{
                      background: "#e0f2fe",
                      padding: "3px 10px",
                      borderRadius: 6,
                      fontWeight: 600,
                      color: "#2563eb",
                      fontSize: 13,
                    }}
                  >
                    {item?.department?.name}
                  </span>
                </div>
                
                {/* Info */}
                <div
                  style={{
                    display: "flex",
                    gap: 2,
                    marginBottom: 6,
                  }}
                >
                  <span style={{ fontSize: 13.5, color: "#555" }}>
                    Người ghi chú:
                    <b style={{ marginLeft: 4, color: "#000" }}>{item?.noteCreator?.staffName}</b>
                  </span>
                </div>

                {/* Ghi chú */}
                <div style={{ marginTop: 6 }}>
                  <span
                    style={{
                      fontSize: 13.5,
                      color: "#000",
                      fontWeight: 600,
                      marginRight: 4,
                    }}
                  >
                    Ghi chú:
                  </span>
                  <span style={{ color: "#444", lineHeight: 1.5 }}>
                    {item?.content}
                  </span>
                </div>

                {/* Chú thích */}
                {/* <div style={{ marginTop: 4 }}>
                  <span
                    style={{
                      fontSize: 13.5,
                      color: "#000",
                      fontWeight: 600,
                      marginRight: 4,
                    }}
                  >
                    Chú thích:
                  </span>
                  <span style={{ color: "#444", lineHeight: 1.5 }}>
                    {item?.remark}
                  </span>
                </div> */}
              </div>
              <div className="flex-center gap-2">
                <Tooltip title="Chỉnh sửa">
                  <div
                    className="flex"
                    onClick={() => {
                      handleOpenFormCreateOrEditNotePatient(item?.id);
                    }}
                  >
                    <IconPen />
                  </div>
                </Tooltip>
                <div className="flex justify-center items-center p-2 gap-4">
                  <Tooltip title="Xóa ghi chú">
                    <div
                      className="flex"
                      onClick={() =>
                        handleDeleteNote(item)
                      }
                    >
                      <IconDelete />
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
          ))}
        </Grid>

        {openNoteCreateOrUpdate && (
          <PopupNotePatient
            open={openNoteCreateOrUpdate}
            handleClose={handleClosePopupNotePatien}
          />
        )}

        <ConfirmPopup
          open={openConfirmDeleteNotePatient}
          onClose={handleClosePopupNotePatien}
          text={t("Bạn có chắc chắn muốn xóa bản ghi này không?")}
          onConfirm={handleDeleteNotePatient}
        />
      </Grid>
    </div>
  );
};

export default memo(observer(ListNoteBlock));
